const protectedPages = [
    'login',
    'error',
    'index',
    '_db'
];

export {
    protectedPages
}